import React, { useEffect, useState } from 'react';
import { Row, Col, Navbar, NavItem, NavDropdown, Nav, Container, Accordion, Dropdown } from 'react-bootstrap';
import icon1 from "../../src/styles/images/lefticon.svg";
import users from "../../src/styles/images/usermanagementicon.svg";
import smalllogo from "../../src/styles/images/logosmall.svg";
import app from "../../src/styles/images/app.svg";
import styles from "./scss/leftmenu.module.scss";
import { useSelector } from 'react-redux';


import logofull from "../styles/images/logofull.svg";
import menu5 from "../styles/images/menu/menu5.svg";
import menu5active from "../styles/images/menu/menu5active.svg";
import profilemenuactive from "../styles/images/menu/profile-menuactive.svg";
import profilemenu from "../styles/images/menu/profile-menu.svg";
import { Link, NavLink } from 'react-router-dom';
import { updateUserType } from '../store/login';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { API_ROUTE_CONTROLLER } from '../app/base/routes';
import { ApiServices } from '../app/base/service/apiService';

const UserLeftMenus = () => {
	const _login = useSelector((state: any) => state.login.login)
	const [noacc, setNoAcc] = useState(false);
	const [productId, setProductId] = useState<any>(15);
	const [checkNull, setCheckNull] = useState<any>('');
	const [RoleName, setRoleName] = useState<any>('')
	console.log("RoleName", RoleName)

	console.log("_login ", _login);

	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [accnav, setAccnav] = useState(false);
	const [usernav, setUsernav] = useState(false);
	const [numnav, setNumnav] = useState(false);
	const [accmaindev, setAccmaindev] = useState(false);
	const [usermaindev, setUsermaindev] = useState(false);
	const [nummaindev, setNummaindev] = useState(false);
	const get_user_with_extensionsdata = async () => {
		const url = API_ROUTE_CONTROLLER.Urmyaccwebgetuserextensioninfo;
		const body = {
			"company_id": _login.company_id,
			"orderid": _login.order_id,
			"extension_number": _login.extension
		};
		ApiServices.post(body, url).then(async (value: any) => {
			//console.log("userInfo", value.data.finalresponse[0].Email);
			let role = JSON.parse(value.data.finalresponse[0].jsonproduct)
			console.log(role)
			// console.log(role[0].RoleName)
			setRoleName(role[0]?.RoleName)

		});
	};

	const notaccordion = () => {
		setNoAcc(true);
	}
	const yesaccordion = () => {
		setNoAcc(false);
	}
	const gotoCompdashboard = () => {
		dispatch(updateUserType("Company"));
		window.open('https://myaccount.worktual.co.uk/overview', '_blank');

	}
	const gotodashboard = () => {
		window.open('https://app.worktual.co.uk/chats', '_blank');
	}
	const gotoWorktualapp = () => {
		window.open('https://app.worktual.co.uk/chats', '_blank');
	}

	const gotoCcaasApp = () => {
		if (RoleName == "Admin" || RoleName == "Owner") {
			window.open('https://ccaas.worktual.co.uk/dashboard', '_blank');
		} else {
			window.open('https://ccaas.worktual.co.uk/agentDashboard', '_blank');
		}
	}

	const accmenu = () => {
		setAccnav(true);
	}
	const usermenu = () => {
		setUsernav(true);		

	}
	const nummenu = () => {
		setNumnav(true);
	}
	const accmenumain = () => {
		setUsernav(false);
		setNumnav(false);
		setAccmaindev(true);
	}
	const usermenumain = () => {
		setAccnav(false);
		setNumnav(false);
		setUsermaindev(true);
	}
	const nummenumain = () => {
		setAccnav(false);
		setUsernav(false);
		setNummaindev(true);
	}
	const [closing, setClosing] = useState(false);
	const closingmenu = () => {
		setClosing(!closing);
	}

	const getUsersApi = async () => {
		let _url = API_ROUTE_CONTROLLER.Urmyaccwebuserorderextension;
		let _body = {
			"OrderId": _login.order_id,
			"Order_Type": '2'
		};
		ApiServices.post(_body, _url).then(async (value: any) => {
			console.log("value", value)
			const jsonProduct: any = value.data.finalresponse[0].jsonproduct;
			console.log("jsonProduct", jsonProduct)
			setCheckNull(jsonProduct)
			if (!jsonProduct) {
				return '';
			}
			const myArray: any = Array.from(JSON.parse(jsonProduct));
			console.log("myArray", myArray)
			setProductId(myArray[0].Productid);
		}).catch((error) => {
			console.log("errorerror", error);
		});
	};

	useEffect(() => {
		getUsersApi();
		get_user_with_extensionsdata()
	}, [])


	const [isMobile, setIsMobile] = useState(window.innerWidth < 767);
	useEffect(() => {
		window.addEventListener("resize", () => {
			const ismobile = window.innerWidth < 767;
			if (ismobile !== isMobile) setIsMobile(ismobile);
		}, false);
	}, [isMobile]);
	return (
		<>

			{!closing ?
				<div className={styles.leftbars}>
					<div className={styles.columnpads}>
						{/* <img src={logofull} className={`${styles.logofull} biglogo`} />
						<img src={smalllogo} className={`${styles.logos} smalllogo`} /> */}
						<ul className="sidebars">
							<Accordion defaultActiveKey="1">
								{/* <li>
									<NavLink to="/profile" onClick={isMobile ? closingmenu : () => { notaccordion(); plainmenumain(); }}><img src={profilemenu} /><img src={profilemenuactive} className="imgactive" />Profile Settings</NavLink></li> */}

								<Accordion.Item eventKey="1" className={false ? "showAcc" : "hideAcc"} id={accmaindev ? "showingAcc" : "HiddenAcc"} onClick={accmenumain}>
									<Accordion.Header>{!accnav ? <img src={profilemenu} /> : <img src={profilemenuactive} />}My Profile</Accordion.Header>
									<Accordion.Body>
										<li><NavLink to="/profile" onClick={isMobile ? closingmenu : accmenu}>Profile Default</NavLink></li>
										<li><NavLink to="/numbersanddevices" onClick={isMobile ? closingmenu : accmenu}>Numbers & Devices</NavLink></li>
										<li><NavLink to="/linkedaccounts" onClick={isMobile ? closingmenu : accmenu}>Linked Accounts</NavLink></li>
										{/* <li><NavLink to="/profile/security" onClick={isMobile ? closingmenu : accmenu}>Security</NavLink></li> */}
									</Accordion.Body>
								</Accordion.Item>
								{productId == 2 ?
									<Accordion.Item eventKey="2" className={false ? "showAcc" : "hideAcc"} id={usermaindev ? "showingAcc" : "HiddenAcc"} onClick={usermenumain}>
										<Accordion.Header>{!usernav ? <img src={menu5} />: <img src={menu5active}  />}Call Management</Accordion.Header>
										<Accordion.Body>
											{/* <li><NavLink to="/greetings" onClick={isMobile ? closingmenu : accmenu}>Greetings</NavLink></li> */}
											<li><NavLink to="/callhandling-and-forwarding" onClick={isMobile ? closingmenu : usermenu}>Call Handling and Forwarding</NavLink></li>
											<li><NavLink to="/uservoicemail" onClick={isMobile ? closingmenu : usermenu}>Voicemail Settings</NavLink></li>
											<li><NavLink to="/usercalllogs" onClick={isMobile ? closingmenu : usermenu}>Call Logs</NavLink></li>
										</Accordion.Body>
									</Accordion.Item>
									:
								// 	productId == 1 ?
								// 		<Accordion.Item eventKey="2" className={numnav ? "showAcc" : "hideAcc"} id={nummaindev ? "showingAcc" : "HiddenAcc"} onClick={nummenumain}>
								// 			<Accordion.Header>{!numnav ? <img src={menu5} />:<img src={menu5active}  />}Call Management</Accordion.Header>
								// 			<Accordion.Body>
								// 				{/* <li><NavLink to="/greetings" onClick={isMobile ? closingmenu : accmenu}>Greetings</NavLink></li> */}
								// 				{/* <li><NavLink to="/callhandling-and-forwarding" onClick={isMobile ? closingmenu : accmenu}>Call Handling and Forwarding</NavLink></li>
								// 		<li><NavLink to="/uservoicemail" onClick={isMobile ? closingmenu : accmenu}>Voicemail Settings</NavLink></li> */}
								// 				<li><NavLink to="/usercalllogs" onClick={isMobile ? closingmenu : nummenu}>Call Logs</NavLink></li>
								// 			</Accordion.Body>
								// </Accordion.Item>:
								""}
							</Accordion>
						</ul>
						{/* 
						<Dropdown className="bottomapp" drop="end">
							<Dropdown.Toggle variant="success" id="dropdown-basic">
								<p ><img src={app} />Worktual Switchers</p>
							</Dropdown.Toggle>
							<Dropdown.Menu className="bottomapppop">
								{(productId == 1 && checkNull != null) ?
									<ul>

										{(_login.extension == 200) ? <li onClick={gotoCompdashboard}>
											<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M32.6764 21.7912L31.4179 21.0647V19.2269L32.7536 18.4559C33.5397 18.0017 33.9224 17.0836 33.6836 16.2222C33.4009 15.1999 32.9967 14.2011 32.4827 13.2552C32.0501 12.4579 31.1284 12.0717 30.2296 12.3024L28.8259 12.6789L27.5264 11.3816L27.9251 9.89389C28.1591 9.02023 27.7812 8.10056 27.0062 7.66023C26.0817 7.13523 25.0907 6.71156 24.0579 6.40456C23.1834 6.14206 22.2527 6.52406 21.7902 7.32406L21.0624 8.58389H19.2267L18.4551 7.24756C18.0009 6.46139 17.0812 6.07523 16.2201 6.31823C15.1984 6.60023 14.2004 7.00439 13.2531 7.51973C12.4536 7.95306 12.0626 8.87956 12.3016 9.77139L12.6781 11.1757L11.3786 12.4746L9.89156 12.0759C9.01706 11.8411 8.09823 12.2204 7.65923 12.9941C7.13139 13.9219 6.70906 14.9137 6.40356 15.9402C6.14373 16.8139 6.52156 17.7474 7.32306 18.2114L8.58223 18.9392V20.7742L7.24656 21.5466C6.46039 22.0007 6.07773 22.9189 6.31656 23.7802C6.59923 24.8026 7.00339 25.8014 7.51739 26.7472C7.95006 27.5446 8.87306 27.9391 9.77056 27.7001L11.1742 27.3236L12.4737 28.6224L12.0751 30.1087C11.8411 30.9839 12.2189 31.9021 12.9932 32.3424C13.9197 32.8689 14.9102 33.2911 15.9416 33.5996C16.8111 33.8552 17.7474 33.4787 18.2092 32.6786L18.9371 31.4187H20.7734L21.5451 32.7551C21.9091 33.3844 22.5709 33.7552 23.2619 33.7552C23.4334 33.7552 23.6077 33.7316 23.7794 33.6844C24.8017 33.4024 25.8006 32.9967 26.7472 32.4829C27.5474 32.0481 27.9384 31.1216 27.6981 30.2312L27.3216 28.8269L28.6211 27.5281L30.1087 27.9267C30.9839 28.1559 31.9014 27.7822 32.3411 27.0086C32.8689 26.0807 33.2912 25.0889 33.5967 24.0624C33.8557 23.1901 33.4787 22.2566 32.6764 21.7912Z" fill="#00DEA0" />
												<path d="M30.2404 28.6151C29.0654 26.6487 26.7584 25.1179 23.8695 24.3947L23.5919 24.3611C23.349 24.3611 23.107 24.4344 22.8909 24.5549C22.0792 25.0064 21.1465 25.2652 20.1527 25.2652C19.7367 25.2652 19.31 25.2199 18.8769 25.1244C18.327 25.0027 17.8122 24.7972 17.3402 24.5264C17.1195 24.3999 16.8707 24.3217 16.6207 24.3217L16.35 24.3537C13.376 25.0784 10.978 26.6567 9.7627 28.6727C9.6072 28.9309 9.60636 29.2652 9.7607 29.5239C11.1112 31.7867 13.9502 33.4866 17.461 34.0271C18.321 34.1596 19.169 34.2227 19.9954 34.2227C24.6102 34.2227 28.5574 32.2577 30.239 29.4627C30.3937 29.2056 30.3944 28.8727 30.2404 28.6151Z" fill="white" />
												<path d="M18.6482 22.2955C19.1059 22.4026 19.5575 22.4533 19.997 22.4533C23.4285 22.4533 26.1339 19.3603 25.4787 15.8085C25.0895 13.6986 23.4349 11.94 21.3459 11.451C20.8882 11.3438 20.4364 11.293 19.9969 11.293C16.5652 11.293 13.8597 14.3863 14.5154 17.9381C14.9047 20.0478 16.5595 21.8066 18.6482 22.2955Z" fill="white" />
											</svg>

											My Account
										</li> : ''}

										<li onClick={gotoCcaasApp}>
										<svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M32.9773 48.0688H19.1106C17.8965 48.0688 16.9114 47.0843 16.9114 45.8699V36H6.64583C8.58049 48.8248 19.616 58.6667 32.9805 58.6667C46.345 58.6667 57.3805 48.8248 59.3152 36H48.5266C46.7448 42.9357 40.4682 48.0688 32.9773 48.0688Z" fill="#00DEA0" />
												<path d="M32.9877 15.9311C40.4773 15.9311 46.7512 21.0647 48.5288 27.9999H59.3152C57.3805 15.1751 46.345 5.33325 32.9805 5.33325C19.616 5.33325 8.58049 15.1751 6.64583 27.9999H17.4354C19.2184 21.0639 25.4949 15.9311 32.9877 15.9311Z" fill="#00DEA0" />
												<path d="M32.9792 38.3775C32.2421 38.3775 31.6458 37.7812 31.6458 37.0442V26.9556C31.6458 26.2186 32.2421 25.6223 32.9792 25.6223C33.7162 25.6223 34.3125 26.2186 34.3125 26.9556V37.0442C34.3125 37.7812 33.7162 38.3775 32.9792 38.3775Z" fill="black" />
												<path d="M37.3906 36.1016C36.6536 36.1016 36.0573 35.5054 36.0573 34.7683V29.3907C36.0573 28.6536 36.6536 28.0574 37.3906 28.0574C38.1277 28.0574 38.724 28.6536 38.724 29.3907V34.7683C38.724 35.5054 38.1277 36.1016 37.3906 36.1016Z" fill="black" />
												<path d="M28.5781 36.1016C27.8411 36.1016 27.2448 35.5054 27.2448 34.7683V29.3907C27.2448 28.6536 27.8411 28.0574 28.5781 28.0574C29.3152 28.0574 29.9115 28.6536 29.9115 29.3907V34.7683C29.9115 35.5054 29.3152 36.1016 28.5781 36.1016Z" fill="black" />
												<path d="M24.1719 34.2785C23.4348 34.2785 22.8385 33.6823 22.8385 32.9452V31.1615C22.8385 30.4244 23.4348 29.8281 24.1719 29.8281C24.9089 29.8281 25.5052 30.4244 25.5052 31.1615V32.9452C25.5052 33.6823 24.9089 34.2785 24.1719 34.2785Z" fill="black" />
												<path d="M41.7969 34.2785C41.0598 34.2785 40.4635 33.6823 40.4635 32.9452V31.1615C40.4635 30.4244 41.0598 29.8281 41.7969 29.8281C42.5339 29.8281 43.1302 30.4244 43.1302 31.1615V32.9452C43.1302 33.6823 42.5339 34.2785 41.7969 34.2785Z" fill="black" />
											</svg>
											Contact Centre Platform
										</li>
									</ul> :
									<ul>

										{(_login.extension == 200) ? <li onClick={gotoCompdashboard}>
											<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M32.6764 21.7912L31.4179 21.0647V19.2269L32.7536 18.4559C33.5397 18.0017 33.9224 17.0836 33.6836 16.2222C33.4009 15.1999 32.9967 14.2011 32.4827 13.2552C32.0501 12.4579 31.1284 12.0717 30.2296 12.3024L28.8259 12.6789L27.5264 11.3816L27.9251 9.89389C28.1591 9.02023 27.7812 8.10056 27.0062 7.66023C26.0817 7.13523 25.0907 6.71156 24.0579 6.40456C23.1834 6.14206 22.2527 6.52406 21.7902 7.32406L21.0624 8.58389H19.2267L18.4551 7.24756C18.0009 6.46139 17.0812 6.07523 16.2201 6.31823C15.1984 6.60023 14.2004 7.00439 13.2531 7.51973C12.4536 7.95306 12.0626 8.87956 12.3016 9.77139L12.6781 11.1757L11.3786 12.4746L9.89156 12.0759C9.01706 11.8411 8.09823 12.2204 7.65923 12.9941C7.13139 13.9219 6.70906 14.9137 6.40356 15.9402C6.14373 16.8139 6.52156 17.7474 7.32306 18.2114L8.58223 18.9392V20.7742L7.24656 21.5466C6.46039 22.0007 6.07773 22.9189 6.31656 23.7802C6.59923 24.8026 7.00339 25.8014 7.51739 26.7472C7.95006 27.5446 8.87306 27.9391 9.77056 27.7001L11.1742 27.3236L12.4737 28.6224L12.0751 30.1087C11.8411 30.9839 12.2189 31.9021 12.9932 32.3424C13.9197 32.8689 14.9102 33.2911 15.9416 33.5996C16.8111 33.8552 17.7474 33.4787 18.2092 32.6786L18.9371 31.4187H20.7734L21.5451 32.7551C21.9091 33.3844 22.5709 33.7552 23.2619 33.7552C23.4334 33.7552 23.6077 33.7316 23.7794 33.6844C24.8017 33.4024 25.8006 32.9967 26.7472 32.4829C27.5474 32.0481 27.9384 31.1216 27.6981 30.2312L27.3216 28.8269L28.6211 27.5281L30.1087 27.9267C30.9839 28.1559 31.9014 27.7822 32.3411 27.0086C32.8689 26.0807 33.2912 25.0889 33.5967 24.0624C33.8557 23.1901 33.4787 22.2566 32.6764 21.7912Z" fill="#00DEA0" />
												<path d="M30.2404 28.6151C29.0654 26.6487 26.7584 25.1179 23.8695 24.3947L23.5919 24.3611C23.349 24.3611 23.107 24.4344 22.8909 24.5549C22.0792 25.0064 21.1465 25.2652 20.1527 25.2652C19.7367 25.2652 19.31 25.2199 18.8769 25.1244C18.327 25.0027 17.8122 24.7972 17.3402 24.5264C17.1195 24.3999 16.8707 24.3217 16.6207 24.3217L16.35 24.3537C13.376 25.0784 10.978 26.6567 9.7627 28.6727C9.6072 28.9309 9.60636 29.2652 9.7607 29.5239C11.1112 31.7867 13.9502 33.4866 17.461 34.0271C18.321 34.1596 19.169 34.2227 19.9954 34.2227C24.6102 34.2227 28.5574 32.2577 30.239 29.4627C30.3937 29.2056 30.3944 28.8727 30.2404 28.6151Z" fill="white" />
												<path d="M18.6482 22.2955C19.1059 22.4026 19.5575 22.4533 19.997 22.4533C23.4285 22.4533 26.1339 19.3603 25.4787 15.8085C25.0895 13.6986 23.4349 11.94 21.3459 11.451C20.8882 11.3438 20.4364 11.293 19.9969 11.293C16.5652 11.293 13.8597 14.3863 14.5154 17.9381C14.9047 20.0478 16.5595 21.8066 18.6482 22.2955Z" fill="white" />
											</svg>

											My Account
										</li> : ''}

										<li onClick={gotoWorktualapp}>
											<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
												<g clipPath="url(#clip0_571_97179)">
													<path d="M9.29761 9.40625H0V18.7031H9.29761V9.40625Z" fill="white" />
													<path d="M27.9992 5.09975V18.7031H18.5955V14.5005C18.5955 11.6854 16.3117 9.40183 13.4953 9.40183H9.29346V0H22.899C25.7154 0 27.9992 2.28362 27.9992 5.09975Z" fill="#00E2A4" />
													<path d="M18.5945 18.7031V28L9.29688 18.7031H18.5945Z" fill="#00E2A4" />
													<path d="M18.5955 14.501V18.7036L9.29346 9.40234H13.4953C16.3117 9.40234 18.5944 11.6849 18.5944 14.501" fill="white" />
												</g>
												<defs>
													<clipPath id="clip0_571_97179">
														<rect width="28" height="28" fill="white" />
													</clipPath>
												</defs>
											</svg>
											Worktual Web App
										</li>
									</ul>
								}
							</Dropdown.Menu>
						</Dropdown> */}

					</div>
				</div>
				: ""}

		</>

	);
};
export default UserLeftMenus;